import * as Immutable from 'immutable';

import { createAction } from '../../../Common/_actions/Action';
import VariantPriceStore from '../../_stores/Store/VariantPriceStore';
import PriceStore from '../../../UIData/_stores/PriceStore';

export enum StoreProductListingActionType {
    EditProductListing = "STORE_PRODUCT_LISTING_EDIT_PRODUCT_LISTING",
    RemoveProductListing = "STORE_PRODUCT_LISTING_REMOVE_PRODUCT_LISTING",
    SelectProductListing = "STORE_PRODUCT_LISTING_SELECT_PRODUCT_LISTING",
    ResetProductListings = "STORE_PRODUCT_LISTING_RESET_PRODUCT_LISTINGS",
}

export const EditProductListing = (
	id_product_design: number,
	id_product: number,
	title: string,
	description: string,
	price: PriceStore,
	update_preset: boolean,
	is_modified: boolean,
	disabled_preview_ids?: Array<number>,
	disabled_option_ids?: Array<number>,
	variant_prices?: Immutable.Map<string, VariantPriceStore>,
	squarespace_store_page_id?: string,
) => createAction(StoreProductListingActionType.EditProductListing, {
	id_product_design: id_product_design,
	id_product: id_product,
	title: title,
	description: description,
	price: price,
	update_preset: update_preset,
	is_modified: is_modified,
	disabled_preview_ids: disabled_preview_ids,
	disabled_option_ids: disabled_option_ids,
	variant_prices: variant_prices,
	squarespace_store_page_id: squarespace_store_page_id,
});

export const RemoveProductListing = (id: string) => createAction(StoreProductListingActionType.RemoveProductListing, {
	id: id
});

export const SelectProductListing = (id: string) => createAction(StoreProductListingActionType.SelectProductListing, {
	id: id
});

export const ResetProductListings = () => createAction(StoreProductListingActionType.ResetProductListings, {});

export type StoreProductListingAction =
	ReturnType<typeof EditProductListing> |
	ReturnType<typeof RemoveProductListing> |
	ReturnType<typeof SelectProductListing> |
	ReturnType<typeof ResetProductListings>
